module.exports = __webpack_public_path__ + "static/media/angular.2579fb34.png";